export default __webpack_public_path__ + "static/media/fundoLogin.a44aa40b.jpg";